import React, { useState } from 'react';

const TABS = [
  ['search', 'Ricerca aziende', '/guide/fr_search.gif', 'Ricerca per ragione sociale, partita IVA o REA con suggerimenti automatici.'],
  ['graph', 'Grafo relazioni', '/guide/fr_graph.gif', 'Costruzione del grafo di soci, amministratori e partecipazioni.'],
  ['monitoring', 'Monitoraggio', '/guide/fr_monitoring_tour.gif', 'Aziende monitorate, eventi e regole di avviso.'],
  ['estero', 'Aziende estere', '/guide/es_tour.gif', 'Scelta del Paese, report in tempo reale e investigazione.'],
  ['travel', 'Travel Security', '/guide/sec_travel.gif', 'Mappa del rischio Paese e avvisi per le persone in viaggio.'],
  ['immobili', 'Immobili', '/guide/im_request.gif', 'Richiesta di una visura catastale.'],
];

export default function HomePreview() {
  const [cur, setCur] = useState(0);
  const [id, label, src, caption] = TABS[cur];
  return (
    <section id="anteprima" className="relative py-28 bg-[#050505] border-t border-[#1F1F1F]" data-testid="home-preview">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Anteprima della piattaforma</p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl text-white mb-10">Guarda BOND al lavoro.</h2>
        <div className="flex gap-2 overflow-x-auto pb-3 mb-4">
          {TABS.map(([tid, l], i) => (
            <button key={tid} onClick={() => setCur(i)} className={`shrink-0 h-10 px-5 rounded-full text-sm border transition-colors ${i === cur ? 'bg-[#D4AF37] border-[#D4AF37] text-black font-semibold' : 'border-[#262626] text-[#A3A3A3] hover:border-[#D4AF37]/50'}`} data-testid={`home-preview-tab-${tid}`}>{l}</button>
          ))}
        </div>
        <div className="relative border border-[#D4AF37]/30 bg-[#0A0A0A] p-2 sm:p-3 shadow-[0_0_50px_rgba(212,175,55,0.12)]">
          <div className="flex items-center gap-1.5 px-2 pb-2"><span className="w-2.5 h-2.5 rounded-full bg-[#333]" /><span className="w-2.5 h-2.5 rounded-full bg-[#333]" /><span className="w-2.5 h-2.5 rounded-full bg-[#D4AF37]" /><span className="ml-3 font-mono text-[11px] text-[#525252]">bond · {label.toLowerCase()}</span></div>
          <img key={id} src={src} alt={`Animazione: ${label}`} className="w-full h-auto home-fade bg-white" data-testid="home-preview-media" />
        </div>
        <p className="text-sm text-[#A3A3A3] mt-4" data-testid="home-preview-caption">{caption}</p>
      </div>
    </section>
  );
}
